import {
  UPDATE_INFO,
  UPDATE_CART,
  UPDATE_PRODUCT,
  UPDATE_NEW_PRODUCT,
  BASE_STATE,
  RESTORE,
  FOLOOSI_PRODUCTS,
  UPDATE_LIST,
  UPDATE_LIKE_LIST
} from '../actions/actionTypes';
import _ from 'underscore';
import {
  reactLocalStorage
} from 'reactjs-localstorage';

const defaultState = {
  featuredList: [],
  categoryList: [],
  categoryListAll: [],
  productList: [],
  detail_list : {},
  productDetail: {},
  loginScreen: false,
  registerScreen: false,
  cartItems: Object.keys(reactLocalStorage.getObject("cartItems")).length !== 0 ? reactLocalStorage.getObject("cartItems"):[],
  show_alert: false,
  new_product: {},
  subTotal: reactLocalStorage.get("subTotal") !== undefined ? parseFloat(reactLocalStorage.get("subTotal")) : 0,
  Tax_List : Object.keys(reactLocalStorage.getObject("Tax_List")).length !== 0 ? reactLocalStorage.getObject("Tax_List"):[],
  inclusive_tax : "",
  user : {},
  product_no : "",
  countryList : [],
  country_flag : {
    "2digit": "AE",
    "3digit": "ARE",
    "code": "+971",
    "flag": "ae",
    "name": "United Arab Emirates"
  },
  style : {
    position: "top-center",
    autoClose: 1000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: false,
    progress: undefined,
  },
  additional_product_fees : Object.keys(reactLocalStorage.getObject("additional_product_fees")).length !== 0 ? reactLocalStorage.getObject("additional_product_fees"):[],
  vat_tax : Object.keys(reactLocalStorage.getObject("vat_tax")).length !== 0 ? reactLocalStorage.getObject("vat_tax"): {
    tax_name: "VAT",
    tax_type: "percentage",
    tax_value: 0,
    total : 0
  },
  shipping_fee: reactLocalStorage.get("shipping_fee") !== undefined ? parseFloat(reactLocalStorage.get("shipping_fee")) : 0,
  merchant_id: reactLocalStorage.get("merchant_id") !== undefined ? reactLocalStorage.get("merchant_id") : "",
  send_merchant_id: reactLocalStorage.get("send_merchant_id") !== undefined ? reactLocalStorage.get("send_merchant_id") : "",
  merchant_id_copy : "",
  shipping_fee_copy : 0,
  vat_tax_copy : {},
  Total : reactLocalStorage.get("Total") !== undefined ? parseFloat(reactLocalStorage.get("Total")) : 0,
  addressChange : false,
  editaddressChange:false,
  billing_info : {
      flat_no : "",
      street_name : "",
      city : "",
      country : "AE",
      postal_code : "",
      country_name :  "United Arab Emirates",
      state_name:""
  },
  shipping_info : {
    shipping_flat_no : "",
    shipping_street_name : "",
    shipping_city : "",
    shipping_country : "AE",
    shipping_postal_code : "",
    shipping_country_name :  "United Arab Emirates",
    shipping_state_name:""

  },
  billing_as_shipping :true,
  billing_as_shipping_id:true,
  address_id : "",
  address_added : false,
  productView : false,
  address_list : [],
  additional_product_fees_copy : [],
  merchantList : [],
  voucher_transaction : reactLocalStorage.get("voucher_transaction") !== undefined ? reactLocalStorage.get("voucher_transaction") : "",
  recharge_data : Object.keys(reactLocalStorage.getObject("recharge_data")).length !== 0 ? reactLocalStorage.getObject("recharge_data") : {},
  voucher_transaction_type : reactLocalStorage.get("voucher_transaction_type") !== undefined ? reactLocalStorage.get("voucher_transaction_type") : "",
  is_login_from : ""
};

const picked = (({ billing_info, shipping_info, billing_as_shipping, billing_as_shipping_id, addressChange, address_id }) => ({ billing_info, shipping_info ,billing_as_shipping, billing_as_shipping_id, addressChange, address_id }))(defaultState);
const baseState = JSON.stringify(picked);

export default (state = defaultState, action) => {
  switch (action.type) {
    case UPDATE_INFO:
      return {
        ...state,
        ...action.payload
      };
    case UPDATE_CART:
      console.log("action",action)
      var index = state.cartItems.findIndex(elem => elem.product_no === action.payload.product_no); 
      if(state.cartItems.length !== 0){
        if (index !== -1) {
          var cart_product = state.cartItems;
          cart_product[index].order_quantity = action.payload.action === "add" ? cart_product[index].order_quantity + 1 : cart_product[index].order_quantity - 1;
          cart_product[index].total = cart_product[index].order_quantity * action.payload.product_price;
          //cart_product[index].shipping_fee_total = cart_product[index].order_quantity * cart_product[index].shipping_fee;
          var result = cart_product.filter(function(product) {
            return product.order_quantity !== 0 ;
          });
          return {
            ...state,
            cartItems: result
          };
        } else if(index === -1 && state.cartItems[0] !== undefined && state.cartItems[0].user_id === action.payload.product_id) {
          var product = {
            product_no : action.payload.product_no,
            user_id : action.payload.product_id,
            product_name : action.payload.product_name,
            product_price : action.payload.product_price,
            product_img : action.payload.product_img,
            order_quantity : 1,
            inclusive_tax : action.payload.inclusive_tax,
            total : action.payload.product_price,
            shipping_fee : action.payload.user.product_setting !== null ? action.payload.user.product_setting.shipping_fee : 0,
            shipping_fee_total : action.payload.user.product_setting !== null ? action.payload.user.product_setting.shipping_fee : 0
          }
          var shipping_fee = action.payload.shipping_option.toLowerCase() == "yes" ? action.payload.user.product_setting !== null ? state.shipping_fee + action.payload.user.product_setting.shipping_fee : state.shipping_fee : 0
          return {
            ...state,
            cartItems: [...state.cartItems, product],
            shipping_fee : shipping_fee
          };
        } else if(state.cartItems[0] !== undefined && state.cartItems[0].user_id !== action.payload.product_id) {
          var shipping_fee = action.payload.shipping_option.toLowerCase() == "yes" ? action.payload.user.product_setting !== null ? action.payload.user.product_setting.shipping_fee : 0 : 0
          return {
            ...state,
            show_alert: true ,
            shipping_fee_copy : shipping_fee,
            merchant_id_copy : action.payload.product_id,
            additional_product_fees_copy : action.payload.user.product_setting !== null ? action.payload.user.product_setting.additional_product_fees : [] ,
            new_product : {
              product_no : action.payload.product_no,
              user_id : action.payload.product_id,
              product_name : action.payload.product_name,
              product_price : action.payload.product_price,
              product_img : action.payload.product_img,
              order_quantity : 1,
              inclusive_tax : action.payload.inclusive_tax,
              total : action.payload.product_price,
              shipping_fee : action.payload.user.product_setting !== null ? action.payload.user.product_setting.shipping_fee : 0,
              shipping_fee_total : action.payload.user.product_setting !== null ? action.payload.user.product_setting.shipping_fee : 0
            },
            vat_tax_copy : action.payload.inclusive_tax === "No" ? 
              {
                tax_name: "VAT", 
                tax_type: "percentage",
                tax_value: action.payload.user.product_setting !== null ? action.payload.user.product_setting.vat : 0,
                total : action.payload.user.product_setting !== null ? action.payload.user.product_setting.vat : 0} 
              : 
              {
                tax_name: "VAT",
                tax_type: "percentage",
                tax_value: 0,
                total : 0
              },
            //inclusive_tax : action.payload.inclusive_tax,
            //user : action.payload.user,
            //product_no : action.payload.product_no
          };
        } else {
          return {
            ...state
          }
        }
      } else{
        var product = {
          product_no : action.payload.product_no,
          user_id : action.payload.product_id,
          product_name : action.payload.product_name,
          product_price : action.payload.product_price,
          product_img : action.payload.product_img,
          order_quantity : 1,
          inclusive_tax : action.payload.inclusive_tax,
          total : action.payload.product_price,
          shipping_fee : action.payload.user.product_setting !== null ? action.payload.user.product_setting.shipping_fee : 0,
          shipping_fee_total : action.payload.user.product_setting !== null ? action.payload.user.product_setting.shipping_fee : 0
        }
        var shipping_fee = action.payload.shipping_option.toLowerCase() == "yes" ? action.payload.user.product_setting !== null ? action.payload.user.product_setting.shipping_fee : 0 : 0
        return {
          ...state,
          cartItems: [...state.cartItems, product],
          send_merchant_id : action.payload.product_id,
          shipping_fee : shipping_fee
        };
      }
    case UPDATE_PRODUCT:
      if(state.cartItems[0] === undefined || state.cartItems[0].user_id === action.payload.product_id){
        var productList = state.productList;
        var product_index = productList.findIndex(elem => elem.product_no === action.payload.product_no);
        productList[product_index].order_quantity = action.payload.action === "add" ? productList[product_index].order_quantity + 1 : productList[product_index].order_quantity - 1;  
        return {
          ...state,
          productList : productList
        };
      } 
    case UPDATE_NEW_PRODUCT:
      var cartItems = [state.new_product]
      return {
        ...state,
        show_alert: false,
        cartItems: cartItems,
        productList : state.productList.map((product, idx) => (
          product.product_no === state.new_product.product_no ? { ...product, order_quantity: 1 } : { ...product, order_quantity: 0  }
        ))
      };      
    case BASE_STATE:
      return {
        ...state,
        ...JSON.parse(baseState)
      };  
    case RESTORE:
      return {
        ...state,
        subTotal : 0,
        vat_tax : {
          tax_name: "VAT",
          tax_type: "percentage",
          tax_value: 0,
          total : 0
        },
        shipping_fee : 0,
        vat_tax_copy : {},
        Total : 0,
        additional_product_fees : [],
        voucher_transaction :  "",
        recharge_data :  {},
        voucher_transaction_type :   ""
      };
    case FOLOOSI_PRODUCTS:
      console.log("action",action)
      var foloosi_products =  state.cartItems.length !== 0 ? state.cartItems.some(e => e.hasOwnProperty('unique_id')) : true;
      var index = state.cartItems.findIndex(elem => elem.foloosi_product_id === action.payload.data.foloosi_product_id); 
      if(foloosi_products === true){
        if(state.cartItems.length !== 0 && index !== -1){
          var cart_product = state.cartItems;
          cart_product[index].order_quantity = action.payload.action === "add" ? cart_product[index].order_quantity + 1 : cart_product[index].order_quantity - 1;
          cart_product[index].total = cart_product[index].order_quantity * action.payload.data.product_price;
          var result = cart_product.filter(function(product) {
            return product.order_quantity !== 0 ;
          });
          if(cart_product[0].order_quantity !== 0 ){
            var recharge_data = state.recharge_data;
            recharge_data.quantity = action.payload.action === "add" ? recharge_data.quantity + 1 : recharge_data.quantity - 1;
            return {
              ...state,
              cartItems: result,
              recharge_data : recharge_data
            };
          } else {
            return {
              ...state,
              cartItems: result,
              voucher_transaction : "",
              recharge_data : {},
              voucher_transaction_type : ""
            };
          }
          
        } else if(state.cartItems.length === 0 /*||  index === -1*/) {
          console.log("action.payload.data.product_price",action.payload)
          var product = action.payload.data;
          console.log("product",product)
          product.product_price =  parseFloat(action.payload.data.product_price);
          product.total = parseFloat(action.payload.data.product_price);
          product.order_quantity = 1;

          var voucher_transaction = "Yes";
          var voucher_transaction_type = action.payload.data.sp_key;
          if(action.payload.data.sp_key === "mintroute"){
            var recharge_data = {
              "category_id":action.payload.data.category_id,
              "denomination_id":action.payload.data.denomination_id,
              "recharge_amount":action.payload.data.product_price, 
              "brand_id":action.payload.data.brand_id,
              "quantity":1
            }
          } else {
            var recharge_data = { 
              "category_id":action.payload.data.category_id,
              "product_id":action.payload.data.denomination_id,
              "recharge_amount":action.payload.data.product_price, 
              "quantity":1
            }
          }          
          return {
            ...state,
            cartItems: [...state.cartItems, product],
            voucher_transaction : voucher_transaction,
            recharge_data : recharge_data,
            voucher_transaction_type : voucher_transaction_type
          };
        } else {
          return {
            ...state,
            show_alert: true
            // voucher_transaction : "",
            // recharge_data : {},
            // voucher_transaction_type : ""
          };  
        }
      }
       else {
        return {
          ...state,
          show_alert: true,
          voucher_transaction : "",
          recharge_data : {},
          voucher_transaction_type : ""
        };  
      }
      // return {
      //   ...state
      // }; 
    case UPDATE_LIST:
      console.log('foloosi list',action)
      if(state.cartItems[0] === undefined || state.cartItems[0].unique_id !== undefined){
        var detail_list = state.detail_list;
        console.log('detail_list',state.detail_list)
        detail_list.products.map((list,i)=>{
          if(action.payload.index !== i){
            list.order_quantity = 0;
            list.total = 0;
          }
        })
        detail_list.products[action.payload.index].order_quantity = action.payload.action === "add" ? detail_list.products[action.payload.index].order_quantity + 1 : detail_list.products[action.payload.index].order_quantity - 1; 
        detail_list.products[action.payload.index].total = detail_list.products[action.payload.index].order_quantity * detail_list.products[action.payload.index].amount;  
        return {
          ...state,
          detail_list : detail_list
        };
      }
    case UPDATE_LIKE_LIST:
      console.log('foloosi list',action)
      if(state.cartItems[0] === undefined || state.cartItems[0].unique_id !== undefined){
        var detail_list = state.detail_list;
        console.log("detail_list",detail_list)
      }
      return {
        ...state,
      };
    default:
      return state;
  }
}  


